<template>
  <div>
    <div class="instructions">Enter VIA values (0.0 to 5.0)</div>
    <v-form id="js-via-form" ref="viaForm">
      <p>All entries will be created as NOT VISIBLE to mentees.</p>
      <p>Make all entries Visible or Invisible at once here:</p>
      <v-btn
        id="js-set-visibility-true"
        small
        color="secondary"
        class="mx-2"
        @click="updateAllViaVisibility(true)"
        >Make All Visible</v-btn
      >
      <v-btn
        id="js-set-visibility-false"
        small
        color="secondary"
        class="mx-2"
        @click="updateAllViaVisibility(false)"
        >Make All Hidden</v-btn
      >
      <v-divider class="my-4"></v-divider>
      <v-simple-table class="pl-4">
        <tr>
          <th>
            character strength
          </th>
          <th>value</th>
          <th class="arrow"></th>
          <th class="arrow"></th>
          <th class="visible">visible</th>
        </tr>
        <tr v-for="stat in stats" :key="stat.name">
          <th class="name">{{ stat.name }}</th>
          <td>
            <v-text-field
              :data-area="stat.name"
              :id="`js-area-${stat.name}`"
              outlined
              single-line
              dense
              hide-details
              class="via-value"
              :value="stat.value / 10"
              @blur="updateVia"
              @keyup.enter="updateVia"
              :rules="viaValueRules"
            ></v-text-field>
          </td>
          <td class="arrows">
            <v-icon @click="increaseSubOrder(stat)"
              >mdi-arrow-up-circle-outline</v-icon
            >
          </td>
          <td class="arrows">
            <v-icon @click="decreaseSubOrder(stat)"
              >mdi-arrow-down-circle-outline</v-icon
            >
          </td>
          <td class="visible">
            <v-icon v-if="stat.visible">mdi-check</v-icon>
          </td>
        </tr>
        <template v-for="viaArea in viaAreas">
          <tr v-if="showEmpty(viaArea)">
            <th class="name">{{ viaArea }}</th>
            <td>
              <v-text-field
                value="0"
                :data-area="viaArea"
                :id="`js-area-${viaArea}`"
                outlined
                single-line
                dense
                hide-details
                class="via-value"
                @blur="updateVia"
                @keyup.enter="updateVia"
                :rules="viaValueRules"
              ></v-text-field>
            </td>
          </tr>
        </template>
      </v-simple-table>
    </v-form>
  </div>
</template>

<script>
import eventMixin from "@/mixins/eventMixin"
import draggable from "vuedraggable"

export default {
  mixins: [eventMixin],
  components: { draggable },
  props: {
    userId: { type: Number },
    stats: { type: Array, default: () => [] }
  },
  data: function() {
    return {
      viaValueRules: [
        v =>
          (parseFloat(v) >= 0 && parseFloat(v) <= 5.0) ||
          "Values 0.0 to 5.0 Only"
      ],
      viaAreas: [
        "Appreciation of Beauty and Excellence",
        "Bravery",
        "Creativity",
        "Curiosity",
        "Fairness",
        "Forgiveness",
        "Gratitude",
        "Honesty",
        "Hope",
        "Humility",
        "Humor",
        "Judgment",
        "Kindness",
        "Leadership",
        "Love",
        "Love of Learning",
        "Perspective",
        "Perseverance",
        "Prudence",
        "Self-regulation",
        "Social Intelligence",
        "Spirituality",
        "Teamwork",
        "Zest"
      ]
    }
  },
  methods: {
    updateAllViaVisibility(visible) {
      this.fireEvent("via_result:visibility", {
        visible: visible,
        userId: this.userId
      })
    },
    updateVia(e) {
      let areaName = e.target.getAttribute("data-area")
      let areaValue = parseFloat(e.target.value) * 10

      if (this.$refs.viaForm.validate()) {
        this.fireEvent("via_result:add", {
          userId: this.userId,
          name: areaName,
          value: areaValue,
          visible: 0
        })
      } else {
        console.log("nope")
      }
    },
    showEmpty(areaName) {
      let names = this.stats.map(el => el.name)
      return !names.includes(areaName)
    },
    increaseSubOrder: function(stat) {
      let newSubOrder = 1 + (stat.sub_order ? stat.sub_order : 0)
      this.fireEvent("via_result:increase_sub_order", {
        userId: stat.user_id,
        name: stat.name,
        value: stat.value,
        subOrder: newSubOrder,
        visible: stat.visible
      })
    },
    decreaseSubOrder: function(stat) {
      let newSubOrder = (stat.sub_order ? stat.sub_order : 0) - 1
      this.fireEvent("via_result:increase_sub_order", {
        userId: stat.user_id,
        name: stat.name,
        value: stat.value,
        subOrder: newSubOrder,
        visible: stat.visible
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../scss/variables";
@import "../../scss/buttons";

.via-value {
  width: 100px;
}

.instructions {
  font-size: 1.8em;
  width: 100%;
  text-align: center;
  font-style: italic;
}

th.name {
  width: 300px;
  border-bottom: 1px solid $beige;
  text-transform: uppercase;
  font-style: italic;
}

td {
  border-bottom: 1px solid $beige !important;
  width: 100px;
}

.arrows {
  width: 50px;
}

.visible {
  width: 50px;
}

tr:hover {
  background: $beige !important;
}

table {
  max-width: 600px !important;
}
</style>
